import styled from 'styled-components';

export const SquareSwatch = styled.div<{ color: string; borderColor: string }>`
  width: 12px;
  height: 12px;
  background-color: ${({ color }) => color};
  border: 0.5px solid ${({ borderColor }) => borderColor};
`;
